import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMetselwerkHerstellen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="m26.62 14.25-6 11.94a.56.56 0 0 0 .5.81h12a.56.56 0 0 0 .5-.81l-6-11.94a.56.56 0 0 0-1 0"
      clipRule="evenodd"
    />
    <path
      fill="#FFBFA5"
      d="M22 6H6v28h16z"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M22 10H12V6h10zM10 6H6v4h4zm6 6H6v4h10zm6 6H12v4h10zm-12 0H6v4h4zm12 12H12v4h10zm-12 0H6v4h4zm6-6H6v4h10zm6 0h-4v4h4z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m19.342 10.802-.79-1.578.895-.448 1.21 2.422-1.802 1.04 1.918 1.918-2.258 1.955.921 1.645-.872.488-1.32-2.355 2.063-1.785-2.082-2.081zM32.28 25.5h-5.15v-1h5.15z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M34 25.72a1.72 1.72 0 0 0-3.44 0v7.56a1.72 1.72 0 1 0 3.44 0z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMetselwerkHerstellen);

export default ForwardRef;
